import gql from 'graphql-tag';

import { baseImageGraphqlFields } from '#src/lib/wb-asset/image-graphql-fields';

import { avatarFragment } from '../../user/avatar-fragment';
import { gameStatsFields } from '../../../lib/game-utils/game-stats';

export const orderItemFragment = gql`
  fragment OrderItemFragment on OrderItem {
    id
    type
    amount
    promo {
      id
      code
    }
    membershipOfferId
    content(screenType: hub) {
      id
      title
      description {
        html
      }
      image {
        ${baseImageGraphqlFields}
      }
      legacyImageUrl
      disclosure
    }

    ... on GameBetOrderItem {
      game {
        id
        type
        title
        description
        shortDescription
        betAmount
        startDate
        endDate
        image {
          ${baseImageGraphqlFields}
        }
        ${gameStatsFields}

        ... on FalkorGame {
          hosts {
            ...AvatarFragment
            id
            displayName
            isOfficialCoach
          }
          labels {
            id
            name
          }
          payoutPercentage
          moneyBackGuaranteeDays
          isMembersOnlyGame
          nonMemberEntryFee
          difficulty
          requirements
          averageActivityDuration {
            unit
            value
          }
          duration {
            unit
            value
          }
        }
      }
      paymentPlan
      paymentPlanChoices {
        id
        code
        amount
      }
    }

    ... on GameOrderItem {
      sku
      estimatedNetRevenue
      paymentPlan
      paymentPlanChoices {
        id
        code
        amount
        subscription {
          id
          code
          amount
        }
      }

      game {
        id
        type
        title
        description
        shortDescription
        betAmount
        startDate
        endDate
        image {
          ${baseImageGraphqlFields}
        }
        ${gameStatsFields}

        ... on FalkorGame {
          hosts {
            id
            ...AvatarFragment
            displayName
            isOfficialCoach
          }
          labels {
            id
            name
          }
          payoutPercentage
          moneyBackGuaranteeDays
          isMembersOnlyGame
          nonMemberEntryFee
          difficulty
          requirements
          averageActivityDuration {
            unit
            value
          }
          duration {
            unit
            value
          }
        }
      }
    }

    ... on MembershipOrderItem {
      # New cart designs, NP WB memberships only
      screenContent(screenType: hub) {
        id
        appleIapDisclosureTrial
        backgroundImageLandscape
        backgroundImagePortrait
        body
        bodyTrial
        bodyFootnote
        bodyWithGame
        braintreeDisclosure
        braintreeDisclosureTrial
        cta
        ctaFootnotePrimary
        ctaFootnoteSecondary
        header
        headerTrial
        headerWithGame
        id
        name
        type
        offerImage
        createdAt
        updatedAt
        rate
        rateTrial
      }
      sku
      estimatedNetRevenue
      isFreeTrial
      membershipType
      paymentPlan
      paymentPlanChoices {
        id
        code
        amount
        tier
        subscription {
          code
          amount
          duration {
            unit
            value
          }
        }
      }
      selectedPaymentPlan {
        id
        code
        amount
        tier
        subscription {
          id
          code
          amount
          duration {
            unit
            value
          }
          trialDuration {
            unit
            value
          }
        }
      }
    }
  }

  ${avatarFragment}
`;
